<template>
  <div :class="isH5 ? 'mobile-group-list' : 'pc-group-list'">
    <div class="groups-wrap">
      <p class="group-total-num">
        <img
          src="../../../assets/images/product-details/group-list-title.png"
          alt=""
        />
        <span class="num-wrap">
          <span class="num">{{ totalJoinNum }}</span
          >人正在拼团</span
        >
      </p>
      <ul class="group-items">
        <li
          :class="isJoiningGroup ? 'is-disabled' : ''"
          class="group-item"
          v-for="item in groupList"
          :key="item.group_id"
        >
          <div class="left">
            <img
              class="avatar"
              v-if="item.leaderInfo"
              :src="item.leaderInfo.avatar + '?imageView2/0/w/100'"
              alt=""
            />
            <div class="info">
              <p class="num">
                还差<span>{{ item.diffNum }}</span
                >人成团
              </p>
              <p class="name" v-if="item.leaderInfo">
                团长:{{ item.leaderInfo.nickname }}
              </p>
            </div>
          </div>
          <button
            @click="signUpByJoin(item.group_id)"
            v-preventReClick
            class="join-group"
            :disabled="isJoiningGroup"
          >
            去参团
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isH5: {
      type: Boolean,
      default: false,
    },
    totalJoinNum: {
      type: Number,
      default: 0,
    },
    groupList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isJoiningGroup: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  methods: {
    signUpByJoin(activity_id) {
      this.$emit("signUpByJoin", activity_id);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-group-list {
  --product-group-list-bg: #fff;
  --product-group-list-item-bg: #fff;
  --product-group-list-primary: #{$saas-text-color};
  --product-group-list-secondary: #747573;

  html.dark & {
    --product-group-list-bg: var(--mg-bg-card);
    --product-group-list-item-bg: var(--mg-bg-surface);
    --product-group-list-primary: var(--mg-text-primary);
    --product-group-list-secondary: var(--mg-text-secondary);
  }

  background: var(--product-group-list-bg);
  padding: 10px 16px 0;
  .group-total-num {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    color: var(--product-group-list-secondary);
    line-height: 17px;
    margin-bottom: 8px;
    img {
      width: 12px;
      height: 9px;
      margin-right: 5px;
    }
    .num-wrap {
      display: flex;
      align-items: flex-end;
    }
    .num {
      color: #ff4067;
    }
  }
  .groups-wrap {
    padding: 10px 16px 0;
    background: url("../../../assets/images/product-details/group-list-bg.png");
    background-size: 100% 100%;
    width: 768px;
    height: 113px;
  }
  .group-items {
    display: flex;
    justify-content: space-between;
    li {
      background: var(--product-group-list-item-bg);
      border-radius: 12px;
      width: 360px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
    }
    .left {
      display: flex;
      align-items: center;
    }
    .avatar {
      width: 44px;
      height: 44px;
      border-radius: 8px;
      margin-right: 6px;
    }
    .info {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .num {
      font-weight: 400;
      font-size: 16px;
      color: var(--product-group-list-primary);
      line-height: 22px;
      span {
        color: #ff4067;
      }
    }
    .name {
      position: relative;
      bottom: -3px;
      font-weight: 400;
      font-size: 12px;
      color: var(--product-group-list-secondary);
      line-height: 17px;
    }
    .join-group {
      width: 66px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      background: url("../../../assets/images/product-details/group-item-btn.png");
      background-size: 100% 100%;
    }
  }
}
.mobile-group-list {
  --product-group-list-bg: #fff;
  --product-group-list-item-bg: #fff;
  --product-group-list-primary: #{$saas-text-color};
  --product-group-list-secondary: #747573;

  html.dark & {
    --product-group-list-bg: var(--mg-bg-card);
    --product-group-list-item-bg: var(--mg-bg-surface);
    --product-group-list-primary: var(--mg-text-primary);
    --product-group-list-secondary: var(--mg-text-secondary);
  }

  background: var(--product-group-list-bg);
  padding: 0 0.32rem;
  .groups-wrap {
    width: 100%;
    padding: 0.08rem 0.32rem 0.32rem;
    background: url("../../../assets/images/product-details/group-list-bg-m.png");
    background-size: 100% auto;
    border-radius: 0.32rem;
  }
  .group-total-num {
    display: flex;
    align-items: center;
    font-size: 0.29rem;
    color: var(--product-group-list-secondary);
    line-height: 0.56rem;
    margin-bottom: 0.19rem;
    img {
      width: 0.26rem;
      height: 0.2rem;
      margin-right: 0.11rem;
    }
    .num-wrap {
      display: flex;
      align-items: flex-end;
      line-height: 0.56rem;
    }
    .num {
      font-weight: 600;
      font-size: 0.4rem;
      color: #ff4067;
      line-height: 0.6rem;
      margin-right: 0.05rem;
    }
  }
  .group-items {
    li {
      background: var(--product-group-list-item-bg);
      border-radius: 0.24rem;
      width: 100%;
      height: 1.63rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.21rem;
      margin-top: 0.21rem;
    }
    li:first-child {
      margin-top: 0;
    }
    .left {
      display: flex;
      align-items: center;
    }
    .avatar {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 0.16rem;
      margin-right: 0.16rem;
    }
    .info {
      padding: 0.11rem 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .num {
      font-weight: 400;
      font-size: 0.37rem;
      color: var(--product-group-list-primary);
      line-height: 0.53rem;
      span {
        color: #ff4067;
      }
    }
    .name {
      font-weight: 400;
      font-size: 0.29rem;
      color: var(--product-group-list-secondary);
      line-height: 0.4rem;
    }
    .join-group {
      width: 1.87rem;
      height: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 0.37rem;
      color: #ffffff;
      line-height: 0.53rem;
      background: url("../../../assets/images/product-details/group-item-btn.png");
      background-size: 100% 100%;
    }
  }
}
.group-item.is-disabled {
  .join-group {
    opacity: 0.5;
  }
}
</style>
